<button mat-stroked-button [disableRipple]="true" (click)="openCancelDialog(meeting)" *ngIf="!isMatItem">
  {{ displayText ? displayText : ('MEETING_SCHEDULER.MEETING_ACTIONS.CANCEL_MEETING' | translate) }}
</button>

<div class="cancel-mat-menu-item" *ngIf="isMatItem" (click)="openCancelDialog(meeting)">
  {{ displayText ? displayText : ('MEETING_SCHEDULER.MEETING_ACTIONS.CANCEL_MEETING' | translate) }}
</div>
